<template lang="pug">

  v-card(class="pa-4")

    div(v-show="showSimpleLoading")
      SimpleLoading

    v-row
      v-col
        h2(class="grey--text text--darken-2") {{ $t('weekDonutChart.TITLE') }}
    v-row(justify="center")

      v-col(v-show="!isDataEmpty" sm="10" xs="12" md="10" lg="6" xl="5")
        apexchart(type="donut" :options="donutOptions" :series="dSeries" ref="donutChart")
      v-col(v-show="isDataEmpty" sm="12" xs="12" md="12" lg="10" xl="10")
        h4(class="text-center grey--text") {{ $t('multiAxisChart.NODATA') }}
</template>

<script>
// import { mapActions } from 'vuex'
import SimpleLoading from '@/components/core/SimpleLoading.vue'

export default {
  data: function() {
        return {
          // -------
          isDataEmpty: false,
          showSimpleLoading: false,
          dSeries: [],
          donutOptions: {
            colors : ['#009DFF', '#00B1FF', '#42C6FF', '#89D8FF', '#C5ECFF', '#E3F6FF', '#F0FAFF'],
            dataLabels: {
              enabled: false,
            },
            tooltip: {
              enabled: true,
              fillSeriesColor: false,
            },
            labels: [`${this.$t('weekDonutChart.SUNDAY')}`, `${this.$t('weekDonutChart.MONDAY')}`, `${this.$t('weekDonutChart.TUESDAY')}`, `${this.$t('weekDonutChart.WEDNESDAY')}`, `${this.$t('weekDonutChart.THURSDAY')}`, `${this.$t('weekDonutChart.FRIDAY')}`, `${this.$t('weekDonutChart.SATURDAY')}`],
            locales: this.$store.getters.locale
          }

        }
      },
      components: {
        SimpleLoading
      },
      methods:{

        mountChart () {
          var arraySum = this.donutChartData.reduce(function(a, b){
            return a + b;
          }, 0);
          if(arraySum == 0){ this.isDataEmpty = true }else{ this.isDataEmpty = false }

          this.showSimpleLoading = true
          this.dSeries = this.donutChartData

          this.donutOptions = {
            labels: [`${this.$t('weekDonutChart.SUNDAY')}`, `${this.$t('weekDonutChart.MONDAY')}`, `${this.$t('weekDonutChart.TUESDAY')}`, `${this.$t('weekDonutChart.WEDNESDAY')}`, `${this.$t('weekDonutChart.THURSDAY')}`, `${this.$t('weekDonutChart.FRIDAY')}`, `${this.$t('weekDonutChart.SATURDAY')}`],
            locales: this.$store.getters.locale
          }
          this.showSimpleLoading = false
        }

      },

      computed: {
        donutChartData(){
          // var arraySum = this.$store.state.adminDash.donutChart.reduce(function(a, b){
          //   return a + b;
          // }, 0);
          // if(arraySum == 0){ this.isDataEmpty = true }else{ this.isDataEmpty = false }
          return this.$store.state.adminDash.donutChart
        },
        lang(){
          return this.$store.getters.locale
        }
      },

      watch: {
        donutChartData () {
          this.mountChart()
        },

        lang () { // se trocou a linguagem, remonta o gráfico
          this.mountChart()
        }

      }

}
</script>
